import styled from 'styled-components'

export const Content = styled.div`
  width: 100%;
  margin-top: 1rem;
  overflow-y: auto;
  font-family: 'Inter', sans-serif;
  min-height: 80%;
  max-height: 80%;
  padding-bottom: 2.5rem;
  box-sizing: border-box;
  scroll-padding-bottom: 2.5rem;

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #c0c0c0;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ffffff;
    border-radius: 10px;
    border: 2px solid #c0c0c0;
  }
`